'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import axios from "axios";
import Configuration from "@/Common/Configuration";
import Utility from "@/Common/Utility";
var ApiService = {
  LastPostUrl: "",
  Query: function Query(dataName, requestObj) {
    var resultPromise;
    var url; //url = Configuration.BaseUrl + "api/" + dataName + "/Get";

    url = Utility.GetBaseUrl() + "api/" + dataName + "/Get";

    if (requestObj == null) {
      requestObj = {};
    }

    resultPromise = this.Get(url, requestObj);
    return resultPromise;
  },
  Get: function Get(url, arg) {
    var resultPromise;

    if (url.indexOf("http") < 0) {
      //url = Configuration.BaseUrl + url;
      url = Utility.GetBaseUrl() + url;
    }

    resultPromise = new Promise(function (resolve, reject) {
      axios.post(url, arg).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        alert("error : " + err);
        reject(err);
      });
    });
    return resultPromise;
  } //end Get: function (url,params) {
  ,
  //用於新增
  Post: function Post(url, arg) {
    var resultPromise;
    var systemUserJson, systemUser;
    var matchTokens;
    var branchNo;
    var bags = [];
    var i;

    if (arg == null) {
      arg = {};
    }

    if (url.indexOf("http") < 0) {
      //url = Configuration.BaseUrl + url;
      url = Utility.GetBaseUrl() + url;
    }

    if (url.indexOf("Query") < 0 && url.indexOf("Detail") < 0) {
      Utility.OnDataModify();
    }

    bags = Utility.GetAllBags();

    if (arg != null && _typeof(arg) == "object") {
      arg.Bag = {};

      for (i = 0; i < bags.length; i++) {
        arg.Bag[bags[i].Name] = bags[i].Value;
      }

      Utility.ProcessResponseData(arg);
    }

    this.LastPostUrl = url;
    resultPromise = new Promise(function (resolve, reject) {
      axios.post(url, arg).then(function (response) {
        if (response.data != null && _typeof(response.data) == "object") {
          response.data.CreateTime = new Date();
        }

        resolve(response.data);
      }).catch(function (err) {
        if (err.response == null) {
          Utility.ShowServerError(err);
        } else {
          if (err.response.data != null && err.response.data.errors != null) {
            var keyName;
            keyName = Object.keys(err.response.data.errors)[0];
            Utility.ShowServerError(err.response.data.title + "\r\n" + err.response.data.errors[keyName]);
          } else {
            Utility.ShowServerError(err.response.data);
          }
        }

        reject(err);
      });
    });
    return resultPromise;
  } //end Post: function (url, params) {
  ,
  Put: function Put(url, params) {
    var resultPromise;
    resultPromise = new Promise(function (resolve, reject) {
      axios.put(url, {
        params: params
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        alert("error : " + err);
        reject(err);
      });
    });
    return resultPromise;
  } //end Put : function (url, params) {
  ,
  Delete: function Delete(url, params) {
    var resultPromise;
    resultPromise = new Promise(function (resolve, reject) {
      axios.delete(url, {
        params: params
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        alert("error : " + err);
        reject(err);
      });
    });
    return resultPromise;
  } //end Delete: function (url, params) {

};
export default ApiService;